// API Configuration with HARDCODED URLs
const API_CONFIG = {
  // Backend API Base URL - HARDCODED 
  // REACT_APP_API_BASE_URL (build-time) only for local development against a local backend
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://staging-pms.oshohimalayas.com',
  // BASE_URL: 'http://localhost:3000',
  
  // Invoice Service URL
  INVOICE_URL: process.env.REACT_APP_INVOICE_URL || 'https://staging-invoiceservice.oshohimalayas.com',

  // Guest web check-in site (payable link shown in the booking modal)
  WEB_CHECKIN_URL: process.env.REACT_APP_WEB_CHECKIN_URL || 'https://web-checkin.oshohimalayas.com',
  
  // Request timeout in milliseconds
  TIMEOUT: 30000,
  
  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
};

// Debug log to verify configuration
console.log('API Configuration (HARDCODED):', {
  frontend: window.location.hostname,
  baseUrl: API_CONFIG.BASE_URL,
  invoiceUrl: API_CONFIG.INVOICE_URL,
  note: 'URLs are hardcoded - not using .env variables'
});

export default API_CONFIG;

